module.exports = __webpack_public_path__ + "static/media/telefonia_no_valida.bb9b72b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/ValidandoTelefonia/telefonia_no_valida.svg
// module id = 1851
// module chunks = 0